__turbopack_context__.v({
  "collectionCard": "CollectionCardGroup-module__AlNPGq__collectionCard",
  "collectionCardGroupContent": "CollectionCardGroup-module__AlNPGq__collectionCardGroupContent",
  "title": "CollectionCardGroup-module__AlNPGq__title",
  "topLine": "CollectionCardGroup-module__AlNPGq__topLine",
});
